const httpLib = require('./http-library');
const publicConfig = require('../public-config');
const URL = require('../lib/url_utils');
const _ = require('lodash');

const searchUrl = publicConfig.external_address;

module.exports = {
  get (queryObject, activities, callback, size, from) {
    const basePath = window && window.searchVariant ? '/v1/searchB/listings' : '/v1/search/listings';
    const startFrom = from || 0;
    const queryString = this.returnQueryString(queryObject, activities, size, startFrom);
    const requestParams = {
      host: searchUrl,
      path: basePath + '?' + queryString
    };
    httpLib.request(requestParams, (data) => {
      const fullResponse = data.hits || {};
      const listings = fullResponse.hits || [];
      callback(listings, fullResponse);
    });
  },

  returnQueryString (searchParams, activities, size, from) {
    const address = searchParams.location ? encodeURIComponent(searchParams.location.replace(/\-\-/g, ', ').replace(/\-/g, ' ')) : undefined;
    const features = searchParams.features;
    const spaceType = searchParams.space_type;
    const searchTerm = searchParams.search_term;
    const style = searchParams.style;

    const searchKeys = {
      viewport_bbox: searchParams.viewport_bbox,
      bbox_of_interest: searchParams.bbox_of_interest,
      point_of_interest: searchParams.point_of_interest,
      space_use: searchParams.space_use,
      ffilter: 'web-search',
      from,
      number_guests: searchParams.number_guests,
      min_guest: searchParams.min_guest,
      max_guest: searchParams.max_guest,
      price_hourly_min: searchParams.price_hourly_min,
      price_hourly_max: searchParams.price_hourly_max,
      is_instant_book_active: searchParams.is_instant_book_active,
      availability_interval: searchParams.availability_interval
    };

    if (size) {
      searchKeys.size = size;
    }

    const id = searchParams.a || searchParams.use_id || '';

    const act = _.filter(activities, { id: id.toLowerCase() });

    if (id) {
      searchKeys.space_use = act[0].use_type;
      searchKeys.use_subtype = encodeURIComponent(act[0].use_subtype);
      searchKeys.use_id = id;
    }

    if (style) {
      searchKeys.kw_search_style = encodeURIComponent(style);
    }

    if (searchTerm) {
      searchKeys.kw_search_keyword = encodeURIComponent(searchTerm);
    }

    if (features) {
      searchKeys.kw_search_feature = encodeURIComponent(features);
    }

    if (spaceType) {
      searchKeys.kw_search_space_type = encodeURIComponent(spaceType);
    }

    if (!searchParams.bbox_of_interest && !searchParams.point_of_interest) {
      searchKeys.address_bbox = address;
    }
    return URL.getQueryString(searchKeys);
  }
};
